import React from 'react'
import '../../css/general.css'
const Logo = () => {
  return (
    <h1 className='p-0 logo'>Twisted Plans</h1>
  )
}

export default Logo